
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import GoogleAnalytics from '../components/GoogleAnalytics';



function Punetobhimashankarcab() {



  const cardData =
  {
    keyword: ' Pune to Bhimashankar Cab',
    heading: 'SHREE Tours & Travels: Pune to Bhimashankar Cab',
    headingDescription: 'SHREE Tours & Travels offers Pune to Bhimashankar Cab service, providing a comfortable and hassle-free travel experience for pilgrims, nature lovers and tourists. Whether you need a one-way Cab, round trip, or outstation taxi, our well-maintained fleet ensures a smooth and enjoyable ride. With professional drivers, affordable pricing and flexible booking options, we make your journey to Bhimashankar Jyotirlinga convenient and stress-free. Choose SHREE Tours & Travels for the best Pune to Bhimashankar Cab service.',

    top: 'Top Places to Visit in Bhimashankar with SHREE Tours & Travels',

"topPlaces": [
    {
        "title": "Bhimashankar Temple",
        "description": "Bhimashankar Temple is one of the twelve Jyotirlingas of Lord Shiva and a highly revered pilgrimage site. Nestled in the Sahyadri hills, the temple is surrounded by dense forests and offers a spiritually uplifting experience. Devotees from all over visit to seek blessings and the temple’s ancient Nagara-style architecture adds to its divine charm. The temple also serves as a starting point for treks into the Bhimashankar Wildlife Sanctuary."
    },
    {
        "title": "Bhimashankar Wildlife Sanctuary",
        "description": "A paradise for nature lovers and wildlife enthusiasts, the Bhimashankar Wildlife Sanctuary is home to diverse flora and fauna, including the rare Indian Giant Squirrel (Shekru). Spanning lush green forests, waterfalls and rolling hills, the sanctuary offers trekking and birdwatching opportunities, making it an ideal spot for adventure seekers and photographers looking to capture the region’s natural beauty."
    },
    {
        "title": "Gupt Bhimashankar",
        "description": "A hidden gem within the dense forests of Bhimashankar, Gupt Bhimashankar is a mystical spot where a natural Shivling is said to be formed. It is an offbeat and tranquil place, accessible through a short trek amidst lush greenery. The serene surroundings and the sound of flowing water create a meditative atmosphere, making it a perfect spot for those seeking solitude and spiritual rejuvenation."
    },
    {
        "title": "Hanuman Lake",
        "description": "Hanuman Lake is a peaceful and scenic spot ideal for nature lovers and birdwatchers. Surrounded by verdant hills and forested areas, this lake attracts various bird species, including peacocks and herons. Visitors can enjoy a leisurely walk, unwind in nature’s lap and capture beautiful reflections of the landscape in the calm waters of the lake."
    },
    {
        "title": "Nagphani (Duke’s Nose)",
        "description": "Nagphani, also known as Duke’s Nose, is a breathtaking viewpoint offering panoramic views of the Sahyadri mountain range. Popular among trekkers and adventure seekers, this spot provides an exhilarating experience with its challenging trails and stunning landscapes. The location gets its name from its resemblance to a cobra’s hood and is a must-visit for those who enjoy trekking and photography."
    },
    {
        "title": "Ahupe Ghat",
        "description": "Ahupe Ghat is a stunning mountain pass offering breathtaking views of the Konkan region and the Deccan plateau. The ghat is surrounded by dense forests, waterfalls and mist-covered peaks, making it a haven for trekkers and adventure lovers. The journey to Ahupe village through the scenic trails is a rewarding experience, providing an escape into the unspoiled beauty of nature."
    },
    {
        "title": "Bombay Point",
        "description": "One of the lesser-known viewpoints in Bhimashankar, Bombay Point offers mesmerizing sunset views over the Sahyadri hills. It is a tranquil spot where visitors can soak in the beauty of the golden hour while enjoying the fresh mountain air. Ideal for photographers and nature lovers, this viewpoint provides an unforgettable experience of the changing hues of the sky."
    },
    {
        "title": "Shivneri Fort",
        "description": "Located a short distance from Bhimashankar, Shivneri Fort is the birthplace of Chhatrapati Shivaji Maharaj. The fort stands as a historical landmark with well-preserved structures, temples and water tanks. A visit here takes you through the rich heritage of the Maratha empire, making it an enriching experience for history enthusiasts and trekkers alike."
    },
    {
        "title": "Junnar Caves",
        "description": "Junnar Caves, an ancient Buddhist cave complex, is located near Bhimashankar and showcases intricate rock-cut architecture. These caves, dating back to the 2nd century BCE, house beautiful sculptures, carvings and inscriptions that reflect Buddhist teachings and culture. The caves provide a fascinating glimpse into India's historical and spiritual past, making them a must-visit for archaeology lovers."
    },
    {
        "title": "Bhorgiri Fort",
        "description": "Bhorgiri Fort is an offbeat trekking destination near Bhimashankar that offers an exciting mix of history and adventure. Surrounded by lush forests and waterfalls, the fort provides spectacular views of the valley below. The trek to the fort is relatively easy and is ideal for those who love exploring ancient ruins while being immersed in nature."
    }
],  
    
            
"services": [
    {
      "name": "Pune to Bhimashankar Taxi",
      "description": "Travel comfortably with SHREE Tours & Travels by booking a taxi from Pune to Bhimashankar. Our well-maintained fleet and professional drivers ensure a smooth and comfortable journey, making your trip to Bhimashankar temple an enjoyable experience."
    },
    {
      "name": "Pune to Bhimashankar Cab Service",
      "description": "Looking for a reliable Cab service from Pune to Bhimashankar? We offer one-way and round-trip options with affordable pricing, professional drivers and a comfortable ride for your spiritual journey to Bhimashankar."
    },
    {
      "name": "Pune to Bhimashankar One-Way Taxi",
      "description": "Need a one-way taxi from Pune to Bhimashankar? Book with SHREE Tours & Travels for a hassle-free ride. We provide a smooth and budget-friendly travel option to ensure a comfortable visit to Bhimashankar without any hidden charges."
    },
    {
      "name": "Pune to Bhimashankar Round Trip Cab",
      "description": "Planning a round trip to Bhimashankar? Our round-trip Cab service offers flexible options for your return journey, ensuring you have a stress-free and convenient travel experience to and from Bhimashankar."
    },
    {
      "name": "Affordable Pune to Bhimashankar Cab",
      "description": "Get affordable Cab services from Pune to Bhimashankar without compromising on comfort. We offer budget-friendly prices while providing a reliable and smooth ride for your temple visit."
    },
    {
      "name": "Private Taxi for Bhimashankar from Pune",
      "description": "Book a private taxi from Pune to Bhimashankar for a personalized journey. Enjoy privacy, comfort and a smooth ride with our experienced drivers who will ensure your trip is tailored to your needs."
    },
    {
      "name": "Bhimashankar Temple Tour by Cab",
      "description": "Take a spiritual journey to Bhimashankar Temple with our dedicated Cab service. Our professional drivers will take you through a peaceful and scenic route, allowing you to experience the calm and serenity of this sacred site."
    },
    {
      "name": "Bhimashankar Cab Hire",
      "description": "Hire a Cab from Pune to Bhimashankar with SHREE Tours & Travels. We offer a range of vehicles to suit your needs, from budget-friendly options to luxury rides, ensuring a comfortable and convenient trip."
    },
    {
      "name": "Group Travel from Pune to Bhimashankar",
      "description": "Traveling with a group? We offer spacious and comfortable Cabs for group travel from Pune to Bhimashankar. Our vehicles can accommodate large groups, ensuring everyone travels together comfortably to the temple."
    },
    {
      "name": "Book Pune to Bhimashankar Car",
      "description": "Rent a car for your Pune to Bhimashankar journey with ease. Choose from sedans, SUVs and other vehicles for a comfortable ride to Bhimashankar temple, whether for a group or individual trip."
    },
    {
      "name": "Bhimashankar Cab Booking from Pune",
      "description": "Easily book your Cab from Pune to Bhimashankar with our online booking service. Enjoy prompt pickups, timely service and a comfortable ride, all at competitive prices for your convenience."
    },
    {
      "name": "Bhimashankar Trip by Cab",
      "description": "Plan your Bhimashankar trip with our reliable Cab service. Enjoy a smooth, hassle-free ride and experience the scenic beauty along the way as you visit one of the most famous temples in Maharashtra."
    },
    {
      "name": "Pune to Bhimashankar Weekend Taxi",
      "description": "Escape for a weekend trip to Bhimashankar with our taxi service. Enjoy a serene and peaceful journey to the temple and make the most of your weekend getaway in the peaceful surroundings of Bhimashankar."
    },
    {
      "name": "Luxury Cab for Bhimashankar",
      "description": "Experience luxury on your trip to Bhimashankar with our high-end vehicles. Choose from premium vehicles like Innova Crysta or luxury sedans and travel in style to this sacred destination."
    },
    {
      "name": "Bhimashankar Sightseeing by Cab",
      "description": "Explore the scenic beauty of Bhimashankar and its surrounding areas with our sightseeing Cab service. Our experienced drivers will take you to the best viewpoints and attractions, ensuring you make the most of your trip."
    }
  ],

  "tableData": [
    ["- Pune to Bhimashankar Taxi", "- Pune to Bhimashankar Cab Service"],
    ["- Pune to Bhimashankar One-Way Taxi", "- Pune to Bhimashankar Round Trip Cab"],
    ["- Affordable Pune to Bhimashankar Cab", "- Private Taxi for Bhimashankar from Pune"],
    ["- Bhimashankar Temple Tour by Cab", "- Bhimashankar Cab Hire"],
    ["- Group Travel from Pune to Bhimashankar", "- Book Pune to Bhimashankar Car"],
    ["- Bhimashankar Cab Booking from Pune", "- Bhimashankar Trip by Cab"],
    ["- Pune to Bhimashankar Weekend Taxi", "- Luxury Cab for Bhimashankar"],
    ["- Bhimashankar Sightseeing by Cab", "- Bhimashankar Temple Tour by Cab"]
  ],

  
  whychoose: [
    {
      "WhyChooseheading": "Comfortable Journey",
      "WhyChoosedescription": "Our Pune to Bhimashankar Cabs are designed for a comfortable and smooth journey. With spacious interiors, comfortable seating and air-conditioning, you can enjoy the scenic drive while relaxing. Whether you're traveling for religious purposes or simply exploring the area, we ensure a pleasant ride."
    },
    {
      "WhyChooseheading": "Experienced Drivers",
      "WhyChoosedescription": "Our drivers are highly experienced and knowledgeable about the route from Pune to Bhimashankar. They know the best roads to take, ensuring a safe, timely and comfortable journey. You can trust our drivers to make your trip smooth and stress-free while prioritizing your safety."
    },
    {
      "WhyChooseheading": "Affordable Pricing",
      "WhyChoosedescription": "We offer competitive and affordable pricing for your Pune to Bhimashankar Cab ride. With no hidden fees and transparent pricing, you can rely on us for great value without compromising on service quality. Whether you're booking a one-way or round trip, our rates are designed to fit your budget."
    },
    {
      "WhyChooseheading": "Well-Maintained Vehicles",
      "WhyChoosedescription": "Our fleet of vehicles is regularly maintained to ensure that you have a safe and comfortable journey. From mechanical inspections to cleanliness, we take great care in keeping our vehicles in top condition. You can trust that your ride will be smooth, safe and comfortable throughout your trip."
    },
    {
      "WhyChooseheading": "Flexible Rental Options",
      "WhyChoosedescription": "We offer flexible rental packages for your Pune to Bhimashankar trip. Whether you need a Cab for a few hours, a full day, or multiple days, we can customize the rental to suit your specific needs. Choose the option that works best for you and enjoy a personalized experience."
    },
    {
      "WhyChooseheading": "Easy Booking Process",
      "WhyChoosedescription": "Booking a Cab for your Pune to Bhimashankar journey is easy and quick. You can book online through our simple platform or contact our customer service for personalized assistance. Whether you're planning ahead or need a last-minute booking, our process is designed to be hassle-free."
    },
    {
      "WhyChooseheading": "24/7 Availability",
      "WhyChoosedescription": "We offer 24/7 availability for your Pune to Bhimashankar trip. Whether you need a ride early in the morning or late at night, we are ready to serve you at any time. Our around-the-clock service ensures that we are always there to meet your travel needs."
    },
    {
      "WhyChooseheading": "Local Insights",
      "WhyChoosedescription": "Our drivers are not just experts in driving but also have valuable local knowledge. If you’re interested in sightseeing or need recommendations for places to visit near Bhimashankar, they can offer helpful insights and make your trip even more enjoyable."
    },
    {
      "WhyChooseheading": "Customer Satisfaction Guarantee",
      "WhyChoosedescription": "At SHREE Tours & Travels, customer satisfaction is our top priority. We are committed to providing excellent service and ensuring your Pune to Bhimashankar trip is safe, comfortable and enjoyable. With our focus on customer care, we guarantee a hassle-free and memorable experience."
    }
  ]
  
  
  
  
  



        
  }

  const faqData = [
    {
        question: "How can I book a Cab from Pune to Bhimashankar?",
        answer: "You can easily book your Pune to Bhimashankar Cab through our website or by calling our customer service for assistance."
    },
    {
        question: "What types of Cabs do you offer for the Pune to Bhimashankar route?",
        answer: "We offer a variety of vehicles for the Pune to Bhimashankar journey, including sedans, SUVs and MPVs, to suit your preferences and group size."
    },
    {
        question: "Are the rental rates from Pune to Bhimashankar inclusive of fuel?",
        answer: "Fuel charges may vary depending on the rental agreement. Detailed pricing information will be provided during the booking process."
    },
    {
        question: "Can I book a Cab for a one-way trip from Pune to Bhimashankar?",
        answer: "Yes, we offer one-way rental options for your Pune to Bhimashankar trip."
    },
    {
        question: "Do you provide drivers with the rental Cab for the Pune to Bhimashankar trip?",
        answer: "Yes, all our Cabs come with experienced drivers who are familiar with the route to ensure a safe and comfortable journey."
    },
    {
        question: "What is your cancellation policy for a Pune to Bhimashankar Cab booking?",
        answer: "We offer a flexible cancellation policy. Please contact us for detailed information specific to your booking."
    },
    {
        question: "What payment methods do you accept for the Pune to Bhimashankar Cab booking?",
        answer: "We accept various payment methods, including cash, credit/debit cards and mobile wallets for your convenience."
    },
    {
        question: "Are the vehicles insured for the Pune to Bhimashankar trip?",
        answer: "Yes, all our vehicles come with insurance coverage for your safety while traveling."
    },
    {
        question: "Can I request a child seat for my Cab from Pune to Bhimashankar?",
        answer: "Yes, child seats can be arranged upon request at the time of booking."
    },
    {
        question: "What is your contact information for booking a Cab from Pune to Bhimashankar?",
        answer: "For bookings and inquiries, you can reach us at: +91 9594917913."
    }
];

const testimonialsData = [
    {
        text: 'The Pune to Bhimashankar journey was peaceful and enjoyable. The driver was courteous and ensured a safe trip.',
        name: 'Mr. Ramesh Naik',
    },
    {
        text: 'I had a wonderful experience with SHREE Tours & Travels. The ride from Pune to Bhimashankar was smooth and the driver was very helpful.',
        name: 'Miss. Simran Patel',
    }
];






  
  
  


  


  const contactData = {
     heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9594917913",

    ],
    email: "booking@shreecabs24.com"
  };


    const Images = [
    {
        place: "/images/keyword/1.jpg",
        text: "Pune to Kolhapur Cab",
        link: "/Pune-to-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/2.jpg",
        text: "Pune to Mumbai Cab",
        link: "/Pune-to-Mumbai-Cab",
    },
    {
        place: "/images/keyword/3.jpg",
        text: "Pune to Sangli Cab",
        link: "/Pune-to-Sangli-Cab",
    },
    {
        place: "/images/keyword/4.jpg",
        text: "Pune to Mahabaleshwar Cab",
        link: "/Pune-to-Mahabaleshwar-Cab",
    },
    {
        place: "/images/keyword/5.jpg",
        text: "Pune to Bhimashankar Cab",
        link: "/Pune-to-Bhimashankar-Cab",
    },
    {
        place: "/images/keyword/6.jpg",
        text: "Pune to Shirdi Cab",
        link: "/Pune-to-Shirdi-Cab",
    },
    {
        place: "/images/keyword/7.jpg",
        text: "Pune to Nashik Cab",
        link: "/Pune-to-Nashik-Cab",
    },
    {
        place: "/images/keyword/8.jpg",
        text: "Pune Airport Pickup and Drop",
        link: "/Pune-Airport-Pickup-and-Drop",
    },
    {
        place: "/images/keyword/9.jpg",
        text: "Pune To Mumbai Airport Cab",
        link: "/Pune-To-Mumbai-Airport-Cab",
    },
    {
        place: "/images/keyword/10.jpg",
        text: "Mumbai To Pune Cab",
        link: "/Mumbai-To-Pune-Cab",
    },
    {
        place: "/images/keyword/12.jpg",
        text: "Mumbai To Kolhapur Cab",
        link: "/Mumbai-To-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/13.jpg",
        text: "Mumbai To Shirdi Cab",
        link: "/Mumbai-To-Shirdi-Cab",
    },
    {
        place: "/images/keyword/14.jpg",
        text: "Mumbai To Nashik Cab",
        link: "/Mumbai-To-Nashik-Cab",
    },
    {
        place: "/images/keyword/15.jpg",
        text: "Mumbai Airport To Pune Cab",
        link: "/Mumbai-Airport-To-Pune-Cab",
    },
    {
        place: "/images/keyword/16.jpg",
        text: "Kolhapur To Pune Cab",
        link: "/Kolhapur-To-Pune-Cab",
    },
    {
        place: "/images/keyword/17.jpg",
        text: "Kolhapur To Mumbai Cab",
        link: "/Kolhapur-To-Mumbai-Cab",
    },
    {
        place: "/images/keyword/18.jpg",
        text: "Sangli To Pune Cab",
        link: "/Sangli-To-Pune-Cab",
    },
    {
        place: "/images/keyword/19.jpg",
        text: "One Way Taxi in Pune",
        link: "/One-Way-Taxi-in-Pune",
    },
    {
        place: "/images/keyword/20.jpg",
        text: "Best Cab service in Pune",
        link: "/Best-Cab-Service-in-Pune",
    },
    {
        place: "/images/keyword/21.jpg",
        text: "Outstation Cabs Pune",
        link: "/Outstation-Cabs-Pune",
    },
    {
        place: "/images/keyword/22.jpg",
        text: "Swift Dzire Hire in Pune",
        link: "/Swift-Dzire-Hire-in-Pune",
    },
    {
        place: "/images/keyword/23.jpg",
        text: "Xcent Hyundai On Rent in Pune",
        link: "/Xcent-Hyundai-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/24.jpg",
        text: "Nexa Ciaz On Rent in Pune",
        link: "/Nexa-Ciaz-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/25.jpg",
        text: "Honda City On Rent In Pune",
        link: "/Honda-City-On-Rent-In-Pune",
    },
    {
        place: "/images/keyword/26.jpg",
        text: "Ertiga On Rent in Pune",
        link: "/Ertiga-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/27.jpg",
        text: "Innova Cab for Outstation in Pune",
        link: "/Innova-Cab-for-Outstation-in-Pune",
    },
];

  
const images = [
    { src: "/images/ourfleet/1.webp", alt: "Image 1" },
    { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

];

const schemaData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "SHREE Tours & Travels",
  "description": "Book a comfortable and reliable Cab from Pune to Bhimashankar with SHREE Tours & Travels. Enjoy affordable fares, one-way and round-trip options. Call +91 9594917913 for booking!",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Your office address here",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411001",
    "addressCountry": "IN"
  },
  "telephone": "+91-9594917913",
  "url": "https://shreetoursandtravels.in",
  "logo": "https://shreetoursandtravels.in/img/logo.jpg",
  "image": [
    "https://shreetoursandtravels.in/img/pune-to-bhimashankar-cab.jpg",
    "https://shreetoursandtravels.in/img/bhimashankar-tour-cab.jpg"
  ],
  "priceRange": "₹1500 - ₹3500",
  "offers": {
    "@type": "Offer",
    "url": "https://shreetoursandtravels.in/pune-to-bhimashankar-cab-service",
    "priceCurrency": "INR",
    "price": 2000,
    "priceValidUntil": "2025-12-31"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": 4.7,
    "reviewCount": 1600
  },
  "review": [
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Anil Deshmukh"
      },
      "datePublished": "2024-05-10",
      "reviewBody": "A peaceful and comfortable journey to Bhimashankar. The driver was very professional and the Cab was well-maintained. Highly recommend this service!"
    },
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Kavita Patil"
      },
      "datePublished": "2024-06-01",
      "reviewBody": "Had an amazing experience visiting Bhimashankar. The trip was smooth and comfortable, thanks to SHREE Tours & Travels. A great service!"
    }
  ],
  "serviceArea": {
    "@type": "Place",
    "name": "Pune to Bhimashankar Cab Service",
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 18.6924,  // Bhimashankar latitude
      "longitude": 73.7394  // Bhimashankar longitude
    }
  },
  "availableChannel": {
    "@type": "ServiceChannel",
    "serviceUrl": "https://shreetoursandtravels.in/pune-to-bhimashankar-cab-service"
  },
  "keywords": "Pune to Bhimashankar Taxi, Pune to Bhimashankar Cab Service, Pune to Bhimashankar One-Way Taxi, Pune to Bhimashankar Round Trip Cab, Affordable Pune to Bhimashankar Cab, Private Taxi for Bhimashankar from Pune, Bhimashankar Temple Tour by Cab, Bhimashankar Cab Hire, Group Travel from Pune to Bhimashankar, Book Pune to Bhimashankar Car, Bhimashankar Cab Booking from Pune, Bhimashankar Trip by Cab, Pune to Bhimashankar Weekend Taxi, Luxury Cab for Bhimashankar, Bhimashankar Sightseeing by Cab"
};




  return (
    <div>
      <GoogleAnalytics/>
    <Helmet>
  <title>Pune to Bhimashankar Cab Service | SHREE Tours & Travels | Call: +91 9594917913</title>
  <meta name="description" content="Book a comfortable and reliable Cab from Pune to Bhimashankar with SHREE Tours & Travels. Enjoy affordable fares, one-way and round-trip options. Call +91 9594917913 for booking!" />
  <meta name="keywords" content="Pune to Bhimashankar Taxi, Pune to Bhimashankar Cab Service, Pune to Bhimashankar One-Way Taxi, Pune to Bhimashankar Round Trip Cab, Affordable Pune to Bhimashankar Cab, Private Taxi for Bhimashankar from Pune, Bhimashankar Temple Tour by Cab, Bhimashankar Cab Hire, Group Travel from Pune to Bhimashankar, Book Pune to Bhimashankar Car, Bhimashankar Cab Booking from Pune, Bhimashankar Trip by Cab, Pune to Bhimashankar Weekend Taxi, Luxury Cab for Bhimashankar, Bhimashankar Sightseeing by Cab" />
  <meta name="robots" content="index, follow" />
  <script type="application/ld+json">
    {JSON.stringify(schemaData)}
  </script>
</Helmet>

    <section
        className="page-title"
        style={{ backgroundImage: 'url(images/hero.jpg)' }}
      >
        <div className="auto-container">
          <div className="title-outer text-center">
            <h1 className="title">{cardData.keyword} </h1>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
         <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/5.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#0310a8', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <div className='pb-3'>
                <button
                  className="p-3 text-white fw-bold borderrr bg-header"
                  onClick={() => {
                    window.location.href = '/booking';
                  }}
                >
                  Book Your Cab
                </button>
              </div>
              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
            <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for SHREE Tours & Travels </h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                {/* <CustomCarousel items={carouselItems} options={carouselOptions} /> */}

                <TestimonialKeyword testimonials={testimonialsData} />

                
              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
    {Images.map((e) => {
        return (
            <div className="box1">
                <a href={e.link} className="d-flex justify-content-around align-items-center">
                    <div className="b1">
                        <img src={e.place} alt="img" />
                    </div>
                    <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                    </div>
                </a>
            </div>
        );
    })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Fleet</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
               
                </div>
              </div>

             <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #0310a8',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#0310a8' }}>
                      <div>
                      <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>
                      
                      <div className=''>
                        <a href="tel:+919594917913" className="d-block  text-white">
                        <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 9594917913
                      </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:booking@shreecabs24.com" className=" text-white d-block">
                        <i className="fas fa-envelope darkcolorrr"></i> booking@shreecabs24.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                        <i className="fas fa-map-marker-alt darkcolorrr"></i>  SHREE Tours & Travels<br />
                          Maharashtra Co-Operative Housing Society,
                          Yerawada, Pune, Maharashtra India - 411006
                            
                         
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Punetobhimashankarcab;